import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PaymentStatus.css';

const PaymentDecline = () => {
    const navigate = useNavigate();

    return (
        <div className="payment-status-container">
            <div className="payment-status-card">
                <img src="/logo.png" alt="App Logo" className="payment-status-logo" />

                <div className="payment-status-icon-wrapper decline">
                    <svg className="payment-status-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="15" y1="9" x2="9" y2="15"></line>
                        <line x1="9" y1="9" x2="15" y2="15"></line>
                    </svg>
                </div>

                <h1 className="payment-status-title decline">Payment Failed</h1>
                <p className="payment-status-message">
                    Oops! Something went wrong with your transaction. Please try again or contact support.
                </p>

                <div className="payment-status-button-group">
                    <button
                        className="payment-status-button danger"
                        onClick={() => navigate(-1)}
                    >
                        Try Again
                    </button>
                    <button
                        className="payment-status-button secondary"
                        onClick={() => navigate('/')}
                    >
                        Go Home
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PaymentDecline;
